var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBronzeCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "crown 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1956_8945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H40V40H0V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1956_8945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.9845 28.1394C20.4403 28.9692 19.5603 28.9692 19.0171 28.1394L14.0929 22.7516C13.5498 21.9207 13.5498 20.5757 14.0929 19.7469L19.0171 10.1082C19.5603 9.27948 20.4403 9.27948 20.9845 10.1082L25.9087 19.7469C26.4519 20.5757 26.4519 21.9207 25.9087 22.7516L20.9845 28.1394Z",
    fill: "#CC4D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.9846 30.2644C30.4404 31.0942 29.5604 31.0942 29.0172 30.2644L24.093 24.8766C23.5499 24.0457 23.5499 22.7017 24.093 21.8719L31.1225 12.2332C31.6657 11.4045 32.5457 11.4045 33.0899 12.2332L35.9088 21.8719C36.452 22.7017 36.452 24.0457 35.9088 24.8766L30.9846 30.2644Z",
    fill: "#CC4D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.9836 30.2644C10.4394 31.0942 9.55833 31.0942 9.01412 30.2644L4.09096 24.8766C3.5478 24.0457 3.5478 22.7017 4.09096 21.8719L6.90886 12.2332C7.45307 11.4045 8.33412 11.4045 8.87833 12.2332L15.9078 21.8719C16.451 22.7017 16.451 24.0457 15.9078 24.8766L10.9836 30.2644Z",
    fill: "#CC4D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M35.7898 12.7496C34.3203 14.2345 32.9154 15.7833 31.5793 17.3915L26.774 7.98443C26.2298 7.15464 25.3498 7.15464 24.8056 7.98443L20.0003 17.3905L15.1951 7.98443C14.6509 7.15464 13.7698 7.15464 13.2256 7.98443L8.42139 17.3905C7.08536 15.7825 5.68052 14.2341 4.21087 12.7496C3.15824 11.6871 1.59508 11.7509 2.1056 13.8121C3.15824 18.062 3.15824 21.2494 3.15824 26.5617V28.6866C3.15824 29.8138 3.60184 30.8948 4.39147 31.6918C5.1811 32.4888 6.25206 32.9365 7.36876 32.9365H32.6319C33.7486 32.9365 34.8196 32.4888 35.6092 31.6918C36.3988 30.8948 36.8424 29.8138 36.8424 28.6866V26.5617C36.8424 21.2494 36.8424 18.062 37.8951 13.8121C38.4045 11.7509 36.8424 11.6871 35.7898 12.7496Z",
    fill: "#F09540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M23.1576 24.4366C23.1576 25.282 22.8249 26.0927 22.2327 26.6905C21.6404 27.2882 20.8372 27.624 19.9997 27.624C19.1622 27.624 18.3589 27.2882 17.7667 26.6905C17.1745 26.0927 16.8418 25.282 16.8418 24.4366C16.8418 23.5913 17.1745 22.7805 17.7667 22.1828C18.3589 21.585 19.1622 21.2492 19.9997 21.2492C20.8372 21.2492 21.6404 21.585 22.2327 22.1828C22.8249 22.7805 23.1576 23.5913 23.1576 24.4366Z",
    fill: "#0160FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M30.526 24.4366C30.526 24.7157 30.4714 24.9921 30.3655 25.2499C30.2596 25.5078 30.1045 25.742 29.9089 25.9394C29.7133 26.1367 29.4811 26.2932 29.2256 26.3999C28.9701 26.5067 28.6963 26.5616 28.4197 26.5615C28.1432 26.5615 27.8694 26.5064 27.6139 26.3995C27.3584 26.2926 27.1263 26.136 26.9309 25.9386C26.7354 25.7412 26.5803 25.5068 26.4745 25.2489C26.3688 24.991 26.3144 24.7146 26.3145 24.4355C26.3146 23.8718 26.5366 23.3312 26.9316 22.9327C27.3266 22.5342 27.8623 22.3104 28.4208 22.3106C28.9793 22.3107 29.5148 22.5348 29.9096 22.9335C30.3044 23.3322 30.5262 23.8729 30.526 24.4366Z",
    fill: "#0160FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M37.8951 24.4366C37.895 24.7157 37.8404 24.9921 37.7346 25.2499C37.6287 25.5078 37.4735 25.742 37.2779 25.9394C37.0823 26.1367 36.8501 26.2932 36.5946 26.3999C36.3391 26.5067 36.0653 26.5616 35.7887 26.5615C35.5122 26.5615 35.2384 26.5064 34.9829 26.3995C34.7275 26.2926 34.4954 26.136 34.2999 25.9386C34.1044 25.7412 33.9493 25.5068 33.8436 25.2489C33.7378 24.991 33.6834 24.7146 33.6835 24.4355C33.6836 23.8718 33.9056 23.3312 34.3006 22.9327C34.6956 22.5342 35.2313 22.3104 35.7898 22.3106C36.3483 22.3107 36.8838 22.5348 37.2787 22.9335C37.6735 23.3322 37.8952 23.8729 37.8951 24.4366Z",
    fill: "#0160FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M13.6851 24.4366C13.6851 25.0002 13.4633 25.5406 13.0685 25.9391C12.6737 26.3376 12.1382 26.5615 11.5799 26.5615C11.0215 26.5615 10.486 26.3376 10.0912 25.9391C9.69641 25.5406 9.47461 25.0002 9.47461 24.4366C9.47461 23.873 9.69641 23.3325 10.0912 22.934C10.486 22.5355 11.0215 22.3116 11.5799 22.3116C12.1382 22.3116 12.6737 22.5355 13.0685 22.934C13.4633 23.3325 13.6851 23.873 13.6851 24.4366Z",
    fill: "#0160FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M6.31612 24.4366C6.31612 25.0002 6.09431 25.5406 5.6995 25.9391C5.30469 26.3376 4.7692 26.5615 4.21085 26.5615C3.6525 26.5615 3.11702 26.3376 2.72221 25.9391C2.32739 25.5406 2.10559 25.0002 2.10559 24.4366C2.10559 23.873 2.32739 23.3325 2.72221 22.934C3.11702 22.5355 3.6525 22.3116 4.21085 22.3116C4.7692 22.3116 5.30469 22.5355 5.6995 22.934C6.09431 23.3325 6.31612 23.873 6.31612 24.4366Z",
    fill: "#0160FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M36.8424 28.6866C36.8424 29.8138 36.3988 30.8948 35.6092 31.6918C34.8196 32.4888 33.7486 32.9365 32.6319 32.9365H7.36873C6.25203 32.9365 5.18107 32.4888 4.39144 31.6918C3.60181 30.8948 3.1582 29.8138 3.1582 28.6866H36.8424Z",
    fill: "#D96D0A"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeCrown);
export default __webpack_public_path__ + "static/media/BronzeCrown.08e9e0b2f455956c7ee8efb8bcd4b367.svg";
export { ForwardRef as ReactComponent };